import Axios from "../../redux/axiosHandlerGeo";
import React, { Component } from "react";
import { Card } from "react-bootstrap";
import PersonCard from "../components/PersonCard";

class Representative extends Component {
	constructor(props) {
		super(props);
		this.state = {
			people: [],
		};
	}
	componentDidMount() {
		Axios.get("/api/staff/mainPage")
			.then((res) => {
				console.log("staff", res.data);
				// const csvData = this.getCSVData(res.data);
				this.setState({
					people: res.data,
					// csvData,
				});
			})
			.catch((err) => {
				console.log("dataSurvey err", err);
			});

		// const people = [
		// 	{
		// 		name: "टसी न्हर्वु गुरुङ",
		// 		nameEnglish: "Tashi Norbu Gurung",
		// 		designation: "गाउँपालिका अध्यक्ष",
		// 		designationEnglish: "Chairperson",
		// 		email: "N/A",
		// 		phone: "९८६७६०१७७२",
		// 		phoneEnglish: "9867601772",
		// 		address: "लोमन्थाङ गाउँपालिका, गण्डकी प्रदेश,मुस्ताङ",
		// 		addressEnglish: "Lomangthang rural municipality, mustang",
		// 		image: "media/hamropalika/people/st1.jpg",
		// 		containerClass: "col-sm-6 col-md-12 col-xl-6",
		// 	},
		// 	{
		// 		name: "छयुमी विष्ट गुरुङ",
		// 		nameEnglish: "Chaumi Bista Gurung",
		// 		designation: "गाउँपालिका उपाध्यक्ष",
		// 		designationEnglish: "Vice-chariperson",
		// 		email: "N/A",
		// 		phone: "९८६७७६९८८५",
		// 		phoneEnglish: "9867769885",
		// 		address: "लोमन्थाङ गाउँपालिका, गण्डकी प्रदेश,मुस्ताङ",
		// 		addressEnglish: "Lomangthang rural municipality, mustang",
		// 		image: "media/hamropalika/people/st2.jpg",
		// 		containerClass: "col-sm-6 col-md-12 col-xl-6",
		// 	},
		// ];
		// this.setState({ people });
	}
	render() {
		return (
			<div className="row h-100">
				{this.state.people.map((person, index) => {
					return <PersonCard data={person} key={index} />;
				})}
			</div>
		);
	}
}

export default Representative;
